import AddSortingNumberToButtonsSitebar from "./addSortingNumberToButtonsSitebar";
import { buttonQuickBar } from "@helpers/defaults";

export default function QuickBarConfig() {
  const quickBarObject = JSON.parse(HQ.Properties.quickBarConfig);

  // full screen add to array when
  // url has mode = iframe
  const fullScreenIn = {
    icon: "fullscreen-in",
    i18n: "fullscreenIn",
    title: "Fullscreen",
    name: "fullscreen",
    className: "fullscreen-content",
    sortNumber: Object.keys(quickBarObject).length + 15,
    show: true,
  };

  let buttonSitebar =
    HQ.Properties.mode == "iframe"
      ? [...buttonQuickBar, fullScreenIn]
      : buttonQuickBar;

  // find element in object quickBarObject
  buttonSitebar = addNewElementInObject(quickBarObject, buttonSitebar);

  return AddSortingNumberToButtonsSitebar(quickBarObject, buttonSitebar)
    .filter((element) => element.sortNumber !== undefined)
    .sort((a, b) => a.sortNumber - b.sortNumber);
}

// update buttons object replace name and icon from objectQB
// https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/644
function addNewElementInObject(quickBarObject, buttonSitebar) {
  return buttonSitebar.map((element) => {
    const name = element.name;

    const iconReplace = quickBarObject.hasOwnProperty(`${name}_icon`)
      ? quickBarObject[`${name}_icon`].replace("icon-", "")
      : "";

    const titleReplace = quickBarObject.hasOwnProperty(`${name}_title`)
      ? quickBarObject[`${name}_title`]
      : "";

    return {
      ...element,
      iconReplace,
      titleReplace,
    };
  });
}
